import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles } from '../../constants/appConstants';
import { manageSettlementsLoader } from '../loaders/manageSettlements';
import PageLoader from '../loaders/pageLoader';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../Root';

const ManageSettlementsPage = lazy(() => import('../../components/pages/manageSettlements'));

const manageSettlementsPath = '/manage-settlements' as const;

export const settlementRoutes = {
	path: manageSettlementsPath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<ProtectedRoute allowedRoles={defaultAllowedRoles}>
					<Suspense fallback={<PageLoader />}>
						<ManageSettlementsPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, settlementsData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					manageSettlementsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...settlementsData,
				};
			},
		},
	],
};
